module.exports = __webpack_public_path__ + "media/flags/pk-577eb2d4.svg";